import { useNavigate, useLocation, Link } from "react-router-dom";
import { classNames } from "primereact/utils";
import TokenService from "../utils/TokenService";

const MainMenu = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isRegister = location.pathname === "/register";
    const isLogin = location.pathname === "/login";
    // const isVerifyEmail = location.pathname === "/verify-email";

    const homeClicked = (e) => {
        e.preventDefault();
        window.location.href = process.env.REACT_APP_PUBLIC_SITE + "/";
    };

    const loginClicked = (e) => {
        e.preventDefault();
        window.location.href = process.env.REACT_APP_ID_SITE + "/login";
    };

    const registerClicked = (e) => {
        e.preventDefault();
        window.location.href = process.env.REACT_APP_ID_SITE + "/register";
    };

    const logoutClicked = (e) => {
        e.preventDefault();
        navigate("/logout");
    };

    return (
        <div className="layout-topbar shadow-4">
            <div className="layout-topbar-left">
                <button
                    type="button"
                    style={{ cursor: "pointer" }}
                    className="layout-topbar-logo p-link"
                    onClick={homeClicked}
                >
                    <img
                        id="app-logo"
                        src="/assets/layout/images/WallistLogo_Black.png"
                        alt="Wallist"
                        style={{ height: "3rem" }}
                    />
                </button>
                <div className="flex lg:hidden w-full justify-content-end">
                    <a href="#" className="font-bold mr-2" style={{ color: "black" }} onClick={homeClicked}>Home</a>
                    {isRegister && (
                        <a href="#" onClick={loginClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Login</a>
                    )}
                    {isLogin && (
                        <a href="#" onClick={registerClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Register</a>
                    )}
                    {TokenService.isLoggedIn() && (
                        <a href="#" onClick={logoutClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Logout</a>
                    )}
                </div>
            </div>
            <div
                className={classNames("layout-topbar-right", {
                    "layout-topbar-mobile-active": props.mobileTopbarActive,
                })}
            >
                <div className="layout-topbar-actions-left fs-large"></div>
                <div className="layout-topbar-actions-right flex align-items-center gap-3">
                    <div className="relative flex flex-column align-items-center h-full justify-content-center">
                        <div className="absolute text-700 px-2 z-1 bg-white" style={{ top: "3px" }}>Homeowners</div>
                        <div className="text-lg border-1 border-primary border-round-md px-5 pt-3 pb-2 flex flex-column align-items-center" style={{ borderWidth: "2px" }}>
                            <a href={process.env.REACT_APP_PUBLIC_SITE + "/search"} className="mainMenuLink">Find a Pro</a>
                        </div>
                    </div>
                    <div className="relative flex flex-column align-items-center h-full justify-content-center">
                        <div className="absolute text-700 px-2 z-1 bg-white" style={{ top: "3px" }}>Businesses</div>
                        <div className="text-lg border-1 border-primary border-round-md px-5 pt-3 pb-2 flex flex-row align-items-center gap-4" style={{ borderWidth: "2px" }}>
                            <a href={process.env.REACT_APP_BUSINESS_SITE + "/promote"} className="mainMenuLink">Promote</a>
                            <a href={process.env.REACT_APP_BUSINESS_SITE + "/features/field-service-management"} className="mainMenuLink">Operate</a>
                            <a href={process.env.REACT_APP_BUSINESS_SITE + "/engage"} className="mainMenuLink">Engage</a>
                            <a href={process.env.REACT_APP_BUSINESS_SITE + "/pricing"} className="mainMenuLink">Pricing</a>
                        </div>
                    </div>
                    <ul className="layout-topbar-items">
                        <li className="layout-topbar-item">
                            <div style={{ width: '72px' }}>
                                <div className="flex flex-row align-items-center mt-2 text-left">

                                    {TokenService.isLoggedIn() ? (
                                        <a href="#" onClick={logoutClicked} style={{ color: "black" }} className="ml-2 font-bold mr-3 md:mr-6 ml-0">Logout</a>
                                    ) : (
                                        <a href="#" onClick={loginClicked} className="text-lg mainMenuLink">Login</a>
                                    )}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
export default MainMenu;
